import { createActions } from '../../../context';
import * as actions from './class-list.actions';

export const classList = store => ({
    filters: {
        className: '',
        providerId: '',
        classGroupId: ''
    },
    items: [],
    classGroups: [],
    providers: [],
    actions: createActions(actions)(store)
});